import { ApplianceModel, ApplianceSource, ApplianceType } from '~/core/models';
import { isCooktop, isRange } from '~/core/utils';

export const isSourceProgram = (appliance: ApplianceModel) =>
  appliance.productSource === ApplianceSource.PROGRAM;

export const isSourceInStore = (appliance: ApplianceModel) =>
  appliance.productSource === ApplianceSource.IN_STORE;

export const setApplianceType = (
  cookingAppliance: ApplianceModel
): ApplianceModel => {
  const isApplianceRange =
    isRange({ applianceType: cookingAppliance.type }) ||
    isRange({ applianceType: cookingAppliance.consumerDesc });

  const isApplianceCooktop =
    isCooktop({ applianceType: cookingAppliance.type }) ||
    isCooktop({ applianceType: cookingAppliance.consumerDesc });

  const applianceType = isApplianceRange
    ? ApplianceType.RANGE
    : isApplianceCooktop
      ? ApplianceType.COOKTOP
      : ApplianceType.RANGE;

  return {
    ...cookingAppliance,
    applianceType,
  };
};
